import {CARD1Web} from './CoordUtils.js'

let  junLieL="static/bimroad/imgs/badImg/a1L.jpg";
let  junLieM="static/bimroad/imgs/badImg/a1M.jpg";
let  junLieH="static/bimroad/imgs/badImg/a1H.jpg";
let  blockL="static/bimroad/imgs/badImg/a2L.jpg";
let  blockH="static/bimroad/imgs/badImg/a2H.jpg";
let  zongfengL="static/bimroad/imgs/badImg/a3L.jpg";  
let  zongfengH="static/bimroad/imgs/badImg/a3H.jpg";  
let  hengfengL="static/bimroad/imgs/badImg/a4L.jpg";
let  hengfengH="static/bimroad/imgs/badImg/a4H.jpg";
let  kengchaoL="static/bimroad/imgs/badImg/a5L.jpg";
let  kengchaoH="static/bimroad/imgs/badImg/a5H.jpg"; 
let  songshanL="static/bimroad/imgs/badImg/a6L.jpg";
let  songshanH="static/bimroad/imgs/badImg/a6H.jpg"; 
let  chengxianL="static/bimroad/imgs/badImg/a7L.jpg";
let  chengxianH="static/bimroad/imgs/badImg/a7H.jpg";
let  chezheL="static/bimroad/imgs/badImg/a8L.jpg";
let  chezheH="static/bimroad/imgs/badImg/a8H.jpg";
let  bolangL="static/bimroad/imgs/badImg/a9L.jpg";
let  bolangH="static/bimroad/imgs/badImg/a9H.jpg";
let  fanyou="static/bimroad/imgs/badImg/a10.jpg";
let  blockRepair="static/bimroad/imgs/badImg/a11.jpg";
let  hengfengRepair="static/bimroad/imgs/badImg/a12.jpg";
let  zongfengRepair="static/bimroad/imgs/badImg/a13.jpg";
let  jijiang="static/bimroad/imgs/badImg/a14.jpg";

export class ResourceLoader{
	constructor(){
		this.textures = new Array();
		this.texturesrcs = [
		{'name': 'junLieL' , 'path' : junLieL},
		{'name': 'junLieM' , 'path' : junLieM},
		{'name': 'junLieH' , 'path' : junLieH},
		{'name': 'blockL' , 'path' : blockL},
		{'name': 'blockH' , 'path' : blockH},
		{'name': 'zongfengL' , 'path' : zongfengL},
		{'name': 'zongfengH' , 'path' : zongfengH},
		{'name': 'hengfengL' , 'path' : hengfengL},
		{'name': 'hengfengH' , 'path' : hengfengH},
		{'name': 'kengchaoL' , 'path' : kengchaoL},
		{'name': 'kengchaoH' , 'path' : kengchaoH},
		{'name': 'songshanL' , 'path' : songshanL},
		{'name': 'songshanH' , 'path' : songshanH},
		{'name': 'chengxianL' , 'path' : chengxianL},
		{'name': 'chengxianH' , 'path' : chengxianH},
		{'name': 'chezheL' , 'path' : chezheL},
		{'name': 'chezheH' , 'path' : chezheH},
		{'name': 'bolangL' , 'path' : bolangL},
		{'name': 'bolangH' , 'path' : bolangH},
		{'name': 'fanyou' , 'path' : fanyou},
		{'name': 'blockRepair' , 'path' : blockRepair},
		{'name': 'hengfengRepair' , 'path' : hengfengRepair},
		{'name': 'zongfengRepair' , 'path' : zongfengRepair},
		{'name': 'jijiang' , 'path' : jijiang},
		]
	}
	loadTexture(i, textureName ,texturePath, callback){
		var image = new Image();
		image.src = texturePath;
		this.textures[textureName] = image;
		var that  = this;
		// image.onload = function(){
			i++;
			if (i === that.texturesrcs.length) return;
			callback.call(that, i, that.texturesrcs[i].name, that.texturesrcs[i].path, that.loadTexture);
		// } 		
	}
	loadTextures(){
		let counter = this.texturesrcs.length;
		let i = 0;
		this.loadTexture(i, this.texturesrcs[i].name, this.texturesrcs[i].path, this.loadTexture);
		CARD1Web.Resources.textures = this.textures;
	}
}




// WEBPACK FOOTER //
// ./src/plugins/drawings3D/ResourceLoader.js